import AuditTrailTemplate from "components/lib/Shared/AuditTrailTemplate";
import React from "react";
import { useSelector } from "react-redux";

const AuditTrail = () => {
  const { transactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );
  const { transactions } = transactionUnderReview.items;
  const envelopes =
    transactions[0]?.envelopes?.length > 0
      ? // If there are envelopes, get the latest one
        [transactions[0]?.envelopes[transactions[0].envelopes?.length - 1]]
      : [];

  // If there are no envelopes, return a message indicating no documents signed
  if (envelopes?.length > 0) {
    return (
      <div>
        <AuditTrailTemplate envelopes={envelopes} />
      </div>
    );
  } else {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-gray-500">No documents signed electronically.</p>
      </div>
    );
  }
};

export default AuditTrail;
